import { render } from "./dashboard_assesmen_hc_backup.vue?vue&type=template&id=5a2c1ea5&scoped=true"
import script from "./dashboard_assesmen_hc_backup.vue?vue&type=script&lang=js"
export * from "./dashboard_assesmen_hc_backup.vue?vue&type=script&lang=js"

import "./dashboard_assesmen_hc_backup.vue?vue&type=style&index=0&id=5a2c1ea5&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2c1ea5"]])

export default __exports__